<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <div v-bem:floating-button @click="showForm = true">
      <p>{{$t('help.title')}} 💁</p>
      <button>?<span>?</span></button>
    </div>
    <div v-bem:form="{show: showForm}">
      <span v-bem:form:close @click="closeForm">&times;</span>
      <div v-bem:confirm v-if="submitStatus === 'SENT'">
        <div class="intro"><img src="@/assets/img/icons/confirm-green.svg" alt=""></div>
        <div class="content">
          <p>{{$t('help.sent')}}</p>
        </div>
      </div>
      <Loader v-if="submitStatus === 'PENDING'" />
      <div v-if="submitStatus !== 'SENT' && submitStatus !== 'PENDING'">
        <p v-bem:form:title>{{$t('help.title')}}</p>
        <p v-bem:form:description>{{$t('help.sub-title')}}</p>
        <form @submit.prevent="submit" class="row form">
          <div class="row">
            <div class="col-12">
              <div class="form-control">
                <input
                v-model="$v.helpForm.fullname.$model"
                type="text"
                name="fullname"
                :class="{error: $v.helpForm.fullname.$dirty && $v.helpForm.fullname.$invalid}"
                :placeholder="`${$t('form.fullname')} *`"
                >
                <div class="errors" v-if="$v.helpForm.fullname.$dirty">
                  <p v-if="!$v.helpForm.fullname.required">{{$t('form.error.required.fullname')}}</p>
                  <p v-if="!$v.helpForm.fullname.custom_alpha">{{$t('form.error.lettres.fullname')}}</p>
                  <p v-if="!$v.helpForm.fullname.minLength">{{$t('form.error.min.fullname')}}</p>
                  <p v-if="!$v.helpForm.fullname.maxLength">{{$t('form.error.max.fullname')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-control">
                <input
                v-model="$v.helpForm.phone.$model"
                type="tel"
                name="phone"
                :class="{error: $v.helpForm.phone.$dirty && $v.helpForm.phone.$invalid}"
                :placeholder="`${$t('form.phone')} *`"
                >
                <div class="errors" v-if="$v.helpForm.phone.$dirty">
                  <p v-if="!$v.helpForm.phone.required">{{$t('form.error.required.phone')}}</p>
                  <p v-if="!$v.helpForm.phone.custom_phone">{{$t('form.error.valid.phone')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="submit" class="button button--primary"><span class="button__text">{{$t('cta.send')}}</span></button>
              <div class="asterisks">
                <p>{{$t('notices.required')}}</p>
              </div>
            </div>
          </div>
        </form>
        <p v-bem:error v-if="submitStatus === 'SUBMIT_ERROR'">{{$t('form.error.send')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import axios from 'axios'
import { helpers, required, minLength, maxLength } from 'vuelidate/lib/validators'
const custom_alpha = helpers.regex('custom_alpha', /^[a-zA-Z ]+$/)
const custom_phone = helpers.regex('custom_phone', /^((05)|(06)|(07))[0-9]{8}$/)

export default {
  name: 'HelpWidget',
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  mixins: [validationMixin],
  data: () => ({
    showForm    : false,
    submitStatus: '',
    helpForm    : {
      fullname : '',
      phone    : '',
    },
  }),
  validations: {
    helpForm : {
      fullname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      phone: {
        required,
        custom_phone
      },
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitStatus = 'PENDING'
        const params = new URLSearchParams()
        params.append('id_commande', '0')
        params.append('nom', this.helpForm.fullname)
        params.append('brand', 'Renault')
        params.append('type_demande', 'Demande d\'info Onlinestore')
        params.append('telephone', this.helpForm.phone)
        params.append('PassKey', process.env.VUE_APP_TELUS_KEY)
        window.telus.post('/Save_Ld_CB.php', params)
          .then(({status}) => {
            (status === 200 || status === 201) ? this.submitStatus = 'SENT' : this.submitStatus = 'SUBMIT_ERROR'
          })
          .catch(err => {
            this.submitStatus = 'SUBMIT_ERROR'
            console.error(err)
          })
      }
    },
    closeForm() {
      this.showForm = false
      this.submitStatus = ''
      this.helpForm = {
        fullname : '',
        phone    : '',
      }
      this.$v.$reset()
    }
  },
  created() {
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) this.closeForm()
    }
    const calcWindowHeight = () => document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    window.onresize = () => setTimeout(calcWindowHeight, 10)
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style lang="scss">
.help-widget {
  position: fixed;
  bottom: rem(140);
  right: 0;
  opacity: 0;
  animation: slide-in 0.5s forwards;
  animation-delay: 2s;
  z-index: 999999999 !important;
  @include breakpoint(1360) {
    bottom: rem(120);
    animation: slide-in-m 0.5s forwards;
    animation-delay: 2s;
  }
  &__floating-button {
    cursor: pointer;
    p {
      display: inline-block;
      transform: translateY(rem(10));
      background-color: $white;
      padding: rem(12) rem(15);
      @include font-size(17);
      border-radius: rem(16);
      box-shadow: 0px rem(2) rem(20) 0px rgba($dark-blue, 0.2);
      margin-right: 0;
      animation: slide-in-p 0.5s forwards;
      animation-delay: 2s;
      @include breakpoint('charmander') {
        display: none;
      }
    }
    button {
      position: relative;
      float: right;
      cursor: pointer;
      appearance: none;
      border: none;
      text-align: center;
      background-color: rgba(var(--primary-color), 1);
      @include font-size(32);
      font-weight: 900;
      width: 60px;
      height: 60px;
      border-radius: 28px;
      box-shadow: 0px rem(2) rem(20) 0px rgba($dark-blue, 0.2);
      transition: font-size 0.3s ease-out;
      color: $white;
      span {
        @extend %transform-center;
        color: #efdf00;
        background-color: $white;
        width: 74px;
        height: 74px;
        border-radius: 34px;
        padding: rem(12) 0;
        @include font-size(46);
        transform: translate(-50%, -50%) scale(0);
        transition: transform 0.2s ease-in;
      }
      &:hover {
        @include font-size(56);
        span {
          transform: translate(-50%, -50%) scale(1);
        }
      }
    }
  }
  &__form {
    position: absolute;
    bottom: rem(-20);
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: rem(372);
    height: rem(360);
    max-height: 90vh;
    background-color: $white;
    padding: rem(16);
    box-shadow: 0px rem(8) rem(36) 0px rgba($dark-blue, 0.2);
    border-radius: rem(16);
    overflow: hidden;
    display: none;
    z-index: 99;
    &--show {
      display: flex;
      animation: slide-in-f 0.5s forwards;
    }
    &::before,
    &::after {
      content: "";
      position: absolute;
      z-index: 1;
    }
    &::before {
      bottom: 0;
      left: 0;
      width: 100%;
      height: rem(50);
      background-color: rgba(var(--primary-color), 1);
    }
    &::after {
      left: 50%;
      width: 110%;
      background-color: $white;
      height: rem(60);
      bottom: rem(26);
      border-radius: 50%;
      transform: translateX(-50%);
    }
    &-close {
      position: absolute;
      top: rem(8);
      right: rem(16);
      @include font-size(26);
      font-weight: 300;
      color: darken($gray, 50%);
      cursor: pointer;
    }
    p {
      text-align: center;
    }
    &-title {
      @include font-size(24);
      font-weight: 500;
    }
    &-description {
      color: $dark-gray;
      @include font-size(14);
    }
    form {
      margin-top: rem(32);
      padding: 0 rem(50);
      position: relative;
      z-index: 2;
    }
    .form-control {
      font-family: $secondary-font;
      margin-bottom: rem(10);
      min-height: rem(32);
      input[type="text"],
      input[type="email"],
      input[type="tel"] {
        color: $main-color;
        margin-bottom: rem(5);
        padding: 0 rem(20);
        width: 100%;
        height: 36px;
        background: none;
        border: 1px solid darken($gray, 20%);
        border-radius: 0;
        appearance: none;
        @include font-size(14);
        &:focus {
          border-color: rgba(var(--primary-color), 1);
        }
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
          -webkit-text-fill-color: $main-color;
          box-shadow: 0 0 0px 1000px transparent inset;
          transition: background-color 5000s ease-in-out 0s;
          color: $main-color;
        }
        &::-webkit-input-placeholder {
          color: darken($gray, 20%);
        }
        &::-moz-placeholder {
          color: darken($gray, 20%);
        }
        &:-ms-input-placeholder {
          color: darken($gray, 20%);
        }
        &:-moz-placeholder {
          color: darken($gray, 20%);
        }
        &.error {
          color: $error-color;
          border-color: $error-color;
          &::-webkit-input-placeholder {
            color: $error-color;
          }
          &::-moz-placeholder {
            color: $error-color;
          }
          &:-ms-input-placeholder {
            color: $error-color;
          }
          &:-moz-placeholder {
            color: $error-color;
          }
        }
      }
    }
    .asterisks {
      p {
        @include font-size(12);
        color: $main-color;
        margin: rem(10) 0;
      }
    }
  }
  .errors {
    @include font-size(10);
    color: $error-color;
    line-height: 1.2;
    p {
      text-align: left;
      display: none;
      &:first-child {
        display: block;
      }
    }
  }
  &__confirm {
    text-align: center;
    .intro {
      img {
        max-width: rem(60);
      }
    }
    .content {
      margin-top: rem(20);
    }
  }
  &__error {
    color: $error-color;
    margin-bottom: rem(30);
    @include font-size(14);
    max-width: rem(500);
  }
  &--rtl {
    .help-widget__floating-button {
      button {
        font-family: $secondary-font;
        line-height: 2.2;
        span {
          line-height: 2;
          padding: 0;
        }
        &:hover {
          line-height: 1.8;
          span {
            line-height: 2;
          }
        }
      }
    }
  }
  @include breakpoint('charmander') {
    &__form {
      position: fixed;
      width: 100%;
      height: 100vh;
      height: calc(100 * var(--vh));
      max-height: initial;
      bottom: 0;
      left: 0;
    }
    &--show {
      right: 0;
    }
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    right: 0;
  }
  to {
    opacity: 1;
    right: rem(28);
    @include breakpoint(1360) {
      right: rem(0);
    }
  }
}
@keyframes slide-in-m {
  from {
    opacity: 0;
    right: 0;
  }
  to {
    opacity: 1;
    right: rem(14);
  }
}
@keyframes slide-in-f {
  from {
    opacity: 0;
    right: rem(-30);
  }
  to {
    opacity: 1;
    right: 0;
  }
}
@keyframes slide-in-p {
  from {
    margin-right: 0;
  }
  to {
    margin-right: rem(16);
  }
}
</style>
